import { usePage } from '@inertiajs/react'
import { useCallback } from 'react'

/**
 * Hook version: reads the org slug from Inertia shared props and returns
 * a function that prefixes paths with `/o/:slug`.
 *
 * Usage in components:
 *   const pathFor = useOrgPath()
 *   <Link href={pathFor('/inbox')} />
 *   router.visit(pathFor('/bookings'))
 */
export function useOrgPath() {
  const { props } = usePage<{ current_organization?: { slug: string } | null }>()
  const slug = props.current_organization?.slug

  return useCallback((path: string) => {
    if (!slug) return path // admin pages, no org context
    return `/o/${slug}${path}`
  }, [slug])
}

/**
 * Non-hook version for use outside React components (event handlers,
 * callbacks) where you already have the slug.
 */
export function orgPath(slug: string | undefined | null, path: string) {
  if (!slug) return path
  return `/o/${slug}${path}`
}
